import React, { useState, useEffect, useContext } from "react";
import './detalhamento_bolsa.css';

import Detalhamento_bolsa_rede_novos from "./detalhamento_bolsa_rede_novos.jsx";
import Detalhamento_bolsa_rede from "./detalhamento_bolsa_rede.jsx";
import Detalhamento_bolsa_rede_renovados from "./detalhamento_bolsa_rede_renovados.jsx";
import Detalhamento_integral_rede from "./detalhamento_integral_rede.jsx";
import Detalhamento_integral_novos from "./detalhamento_integral_novos.jsx";
import Detalhamento_integral_renovados from "./detalhamento_integral_renovados.jsx";

import { Tabs, Tab } from "react-bootstrap";


const Detalhamento_bolsa_rede_tabs = (props) => {

    return (
        <Tabs defaultActiveKey="Rede" id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="Rede" title="REDE">
                <Detalhamento_bolsa_rede {...props} />
            </Tab>
            <Tab eventKey="novos" title="NOVOS">
                <Detalhamento_bolsa_rede_novos {...props} />
            </Tab>
            <Tab eventKey="renovados" title="RENOVADOS">
                <Detalhamento_bolsa_rede_renovados {...props} />
            </Tab>
            <Tab eventKey="integral" title="REDE INTEGRAL">
                <Detalhamento_integral_rede {...props} />
            </Tab>
            <Tab eventKey="integralNovos" title="REDE INTEGRAL - NOVOS">
                <Detalhamento_integral_novos {...props} />
            </Tab>
            <Tab eventKey="integralRenovados" title="REDE INTEGRAL - RENOVADOS">
                <Detalhamento_integral_renovados {...props} />
            </Tab>
        </Tabs>
    );
};
export default Detalhamento_bolsa_rede_tabs;


